import zenObservable from"zen-observable";var Observable=zenObservable;export default Observable;export{Observable};